import { Image } from "antd";
import { useLocation } from "react-router-dom";
import { checkSite } from "../../api/api";
import { errorNotify } from "../../services/toast.notification";
import { useEffect, useState } from "react";
export interface InputProps {
    url: any
  }
const CheckSite = ({url}:InputProps) => {
    // const { state } = useLocation();
    // const { url } = state; // Read values passed on state
    const [sqlLayerData, setSqlLayerData] = useState<any>(undefined);
    const [businessLayersData, setBusinessLayersData] = useState<any>();
    const [presentationLayersData, setPresentationLayersData] = useState<any>();

    const [isLoading, setIsLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(1);

    const handleTabClick = (id: any) => {
        setActiveTab(id);
    };


    const _checkSite = () => {
        checkSite(url)
            .then((result) => {
                setSqlLayerData(result.data.sqlLayers);
                setBusinessLayersData(result.data.businessLayers);
                setPresentationLayersData(result.data.presentationLayers);


                setIsLoading(false);
                console.log(result);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }
    useEffect(() => {
        _checkSite();
    }, []);

    return (
        <>
            <div>
                <ul className="image-tabs">
                    <li className={activeTab === 1 ? 'active' : ''} onClick={() => handleTabClick(1)}>
                        {sqlLayerData && sqlLayerData.isConnected && (
                            <Image preview={false}
                                style={{ width: '100px', paddingLeft: '20px' }}
                                src='../../assets/icon/database_green.png'
                            />
                        )}
                        {sqlLayerData && !sqlLayerData.isConnected && (
                            <Image preview={false}
                                style={{ width: '100px', paddingLeft: '20px' }}
                                src='../../assets/icon/database_red.png'
                            />
                        )} </li>
                    <li>
                        <Image preview={false}
                            style={{ width: '80px', paddingLeft: '20px' }}
                            src='../../assets/icon/arrow.png'
                        />
                    </li>
                    <li className={activeTab === 2 ? 'active' : ''} onClick={() => handleTabClick(2)}>
                        {businessLayersData && businessLayersData.isIISRun && businessLayersData.isParsicSMSRun && (
                            <Image preview={false}
                                style={{ width: '100px', paddingLeft: '20px' }}
                                src='../../assets/icon/server_green.png'
                            />
                        )}
                        {businessLayersData && !(businessLayersData.isIISRun && businessLayersData.isParsicSMSRun) && (
                            <Image preview={false}
                                style={{ width: '100px', paddingLeft: '20px' }}
                                src='../../assets/icon/server_red.png'

                            />
                        )}
                    </li>
                    <li>
                        <Image preview={false}
                            style={{ width: '80px', paddingLeft: '20px' }}
                            src='../../assets/icon/arrow.png'
                        />
                    </li>
                    <li className={activeTab === 3 ? 'active' : ''} onClick={() => handleTabClick(3)}>
                        {presentationLayersData && presentationLayersData.countGiveResult > 0 && presentationLayersData.countParitelConfirm > 0 && (

                            <Image preview={false}
                                style={{ width: '80px', paddingLeft: '20px' }}
                                src='../../assets/icon/monitor_green.png'
                            />
                        )}
                        {presentationLayersData && !(presentationLayersData.countGiveResult > 0 && presentationLayersData.countParitelConfirm > 0) && (
                            <Image preview={false}
                                style={{ width: '100px' }}
                                src='../../assets/icon/monitor_red.png'
                            />
                        )}
                    </li>
                </ul>
            </div>

            <div className="image-tab-content image-tab-content-padding">
                {
                    activeTab === 1 && <div >
                        <li className={sqlLayerData && sqlLayerData.isConnected ? "green-color" : "red-color"}>
                            اتصال sql
                        </li>
                    </div>
                }
                {
                    activeTab === 2 && <div >
                        <li className={businessLayersData && businessLayersData.isIISRun ? "green-color" : "red-color"}>
                            سرویس IIS
                        </li>
                        <li className={businessLayersData && businessLayersData.isParsicSMSRun ? "green-color" : "red-color"}>
                            سرویس SMS
                        </li>
                    </div>
                }
                {
                    activeTab === 3 && <div >
                        <li className={presentationLayersData && presentationLayersData.countGiveResult > 0 ? "green-color" : "red-color"}>
                            صحت بررسی جوابدهی آنلاین
                            {presentationLayersData && presentationLayersData.countGiveResult > 0 && (<div>
                                تعداد جواب گرفته شده: {presentationLayersData.countGiveResult}
                            </div>
                            )}
                        </li>
                        <li className={presentationLayersData && presentationLayersData.countParitelConfirm > 0 ? "green-color" : "red-color"}>
                            صحت بررسی پارسی تل و پارسی لب
                            {presentationLayersData && presentationLayersData.countParitelConfirm > 0 && (<div>
                                تعداد تایید جواب: {presentationLayersData.countParitelConfirm}
                            </div>
                            )}
                        </li>
                    </div>
                }
            </div>



            {/* <div style={{ direction: 'rtl' }}>
        {sqlLayerData && sqlLayerData.isConnected && (<Image
            style={{ width: '100px', paddingLeft: '20px' }}
            src='../../assets/icon/database_green.png'
        />)}
        {sqlLayerData && !sqlLayerData.isConnected && (<Image
            style={{ width: '100px', paddingLeft: '20px' }}
            src='../../assets/icon/database_red.png'
        />)}
        <Image
            style={{ width: '80px', paddingLeft: '20px' }}
            src='../../assets/icon/arrow.png'
        />
        {businessLayersData && businessLayersData.isIISRun && businessLayersData.isParsicSMSRun && (<Image
            style={{ width: '100px', paddingLeft: '20px' }}
            src='../../assets/icon/server_green.png'
        />)}
        {businessLayersData && !(businessLayersData.isIISRun && businessLayersData.isParsicSMSRun) && (<Image
            style={{ width: '100px', paddingLeft: '20px' }}
            src='../../assets/icon/server_red.png'

        />)}
        <Image
                style={{ width: '80px', paddingLeft: '20px' }}
                src='../../assets/icon/arrow.png'
            />
        {presentationLayersData && presentationLayersData.countGiveResult > 0 && presentationLayersData.countParitelConfirm > 0 &&
            (<Image
                style={{ width: '80px', paddingLeft: '20px' }}
                src='../../assets/icon/monitor_green.png'
            />)}
        {presentationLayersData && !(presentationLayersData.countGiveResult > 0 && presentationLayersData.countParitelConfirm > 0) &&
            (<Image
                style={{ width: '100px' }}
                src='../../assets/icon/monitor_red.png'
            />)}

    </div> */}
        </>)
}
export default CheckSite;